<div id="home">
  <header style="height: 220px">
    <div class="container main-banner">NOTÍCIAS</div>
  </header>
  <section class="noticias container">
    <p class="title text-center" style="font-weight: lighter; margin-bottom: 33px">{{ record?.titlePT }}</p>
    <p class="text">{{ getDescription() }}</p>
    <div *ngIf="record?.imageContentType !== 'video/mp4'" class="container shadow p-2">
      <img [alt]="record?.titlePT ?? 'IPDJ'" class="w-100" src="{{ 'data:' + record?.imageContentType + ';base64,' + record?.image }}" />
    </div>
    <div *ngIf="record?.imageContentType === 'video/mp4'" class="container shadow p-2">
      <video autoplay class="w-100" controls src="{{ 'data:' + record?.imageContentType + ';base64,' + record?.image }}"></video>
    </div>
    <div class="row">
      <a [routerLink]="['/']" class="btn-pg btn-inscreve text-center alternate-color">Voltar </a>
    </div>
  </section>
</div>
